import { useEffect, useState } from "react";
import { servicePatientData, serviceSuperviewActiveUserCount, serviceSuperviewCallDetail, serviceSuperviewInclinicCall, serviceSuperviewMesageGraph } from "../../../Services/Service";
import SkeletonCard from "./SkeletonCard";
import PopupModal from "./PopupModal";
import ChartsSection from "./ChartsSection";
import TrendBreakdownChart from "./TrendBreakdownChart";
import OnboardedPatientsPopup from "./OnboardedPatientsPopup";
import {formatUkNumber} from "../../Utils";

export default (({
  filterForm,
  companyId,
  userData,
  activeUsersLoading,
  fetchServicePatientDataLoading,
  fetchSuperviewCallDetailLoading,
  fetchSuperviewMesageGraphLoading,
  fetchSuperviewInclinicCallLoading,
  activeUsers,
}) => {
  // const [activeUsersLoading, setActiveUsersLoading] = useState(false);
  // const [fetchServicePatientDataLoading, setFetchServicePatientDataLoading] = useState(false);
  // const [fetchSuperviewCallDetailLoading, setFetchSuperviewCallDetailLoading] = useState(false);
  // const [fetchSuperviewMesageGraphLoading, setFetchSuperviewMesageGraphLoading] = useState(false);
  // const [fetchSuperviewInclinicCallLoading, setfetchSuperviewInclinicCallLoading] = useState(false);
  const [showTrendPopup, setShowTrendPopup] = useState(false);
  const [openOnboardedPopup, setOpenOnboardedPopup] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const updateModalTitle = (val) => {
    setModalTitle(val)
  }
  const StatCard = ({
    otherClass = '',
    title = "Active Patients",
    subtitle = "Active Patients",
    imgSrc = "https://appcdn.goqii.com/storeimg/93035_1684235616.png",
    value = 0,
    modelClassName = 'superadminboxN',
    modal = "modal",
    target = "superAdminModal",
    isLoading = false,
    isClick = true,
    ...props
  }
  ) => {
    return (
      <>
        <SkeletonCard className={`${!isLoading && 'd-none'} col-12 col-sm-6 col-md-4 col-lg col-xl mt-3 px-1 `} />
        <div
          className={`col-12 col-sm-6 col-md-4 col-lg col-xl mt-3 px-1 ${isLoading && 'd-none'} ${otherClass}`}
          style={{ position: "relative" }}
          {...props}
        >
          {title === "Fully Onboarded Patients" && (
            <i
              onClick={() => setOpenOnboardedPopup(true)}
              className="bi bi-eye"
              style={{
                position: "absolute",
                top: "8px",
                right: "12px",
                fontSize: "1.2rem",
                color: "#333",
                zIndex: 2,
                cursor: "pointer",
                color:'#2491e7'
              }}
            ></i>
          )}
          <a
            className={modelClassName}          
            data-bs-toggle={isClick?modal:''}
            data-bs-target={`#${target}`}
            onClick={() =>{
              if(isClick){                
                updateModalTitle(title)
              } 
            }}
          >
            <img
              src={imgSrc}
              alt=""
              className="imgicon mb-2"
            />
            <h1 className="titlenumbers">
              {value}
            </h1>
            <h2 className="subtitle">
              {subtitle}
            </h2>
          </a>
        </div>
      </>
    );
  }

  return <>
    <PopupModal title={modalTitle} filterForm={filterForm} onClose={() => updateModalTitle('')} />
    {openOnboardedPopup && (
      <>
        {/* Overlay: covers the whole screen, disables background interaction */}
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.4)",
            zIndex: 1040,
            pointerEvents: "auto",
          }}
          onClick={() => setOpenOnboardedPopup(false)}
        />
        {/* Popup itself (with higher z-index) */}
        {/* <div
            style={{
              position: "fixed",
              zIndex: 1051,
              left: 0,
              top: 0,
              width: "100vw",
              height: "100vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          > */}
        <OnboardedPatientsPopup
          onboarded={userData?.onboarded}
          onClose={() => setOpenOnboardedPopup(false)}
          filterForm={filterForm}
        />
        {/* </div> */}
      </>
    )}

    {showTrendPopup && (
      <>
        {/* Overlay: covers the whole screen, disables background interaction */}
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.4)",
            zIndex: 1040,
            pointerEvents: "auto",
          }}
          onClick={() => setShowTrendPopup(false)}
        />
        {/* Popup itself (with higher z-index) */}
        <div
          style={{
            position: "fixed",
            zIndex: 1051,
            left: 0,
            top: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <TrendBreakdownChart onClose={() => setShowTrendPopup(false)} />
        </div>
      </>
    )}


    <div className="row mb-10 px-2">
      <StatCard
        title="Active Patients"
        subtitle="Active Patients"
        imgSrc="https://appcdn.goqii.com/storeimg/93035_1684235616.png"
        value={formatUkNumber(activeUsers?.count)}
        isLoading={activeUsersLoading}
      />

      {/* <div
        className="d-flex justify-content-end align-items-center"
        style={{ marginTop: "10px"}}
       
      >
      <span style={{ cursor: "pointer" }} onClick={() => setShowTrendPopup(true)}>
        <i
          className="bi bi-graph-up"
          style={{
            color: "#007BFF",
            fontWeight: 700,
            fontSize: "0.8rem",
            marginRight: "5px",
          }}
        ></i>
        <span
          style={{
            fontWeight: 700,
            fontSize: "0.8rem",
            color: "#007BFF",
            marginRight: "4px",
          }}
        >
          View Trend
        </span>
        </span>
      </div> */}
      <div className="col-12 px-3">
        <div className="row">
          <StatCard
            title="Accounts Created"
            subtitle="Accounts Created"
            imgSrc="https://appcdn.goqii.com/storeimg/13688_1684235547.png"
            value={formatUkNumber(userData?.total)}
            isLoading={activeUsersLoading}
          />
          <StatCard
            title="Partially Registered Patients"
            subtitle="Partially Registered Patients"
            imgSrc="https://appcdn.goqii.com/storeimg/59789_1681803187.png"
            value={formatUkNumber(userData?.partialOnboard)}
            isLoading={activeUsersLoading}
          />
          <StatCard
            title="Fully Onboarded Patients"
            subtitle="Fully Onboarded Patients"
            imgSrc="https://appcdn.goqii.com/storeimg/88760_1681801347.png"
            value={formatUkNumber(userData?.onboarded)}
            isLoading={activeUsersLoading}
          />
         
          
          <StatCard
            title="Opt-Out Patients"
            subtitle="Opt-Out Patients"
            imgSrc="https://appcdn.goqii.com/storeimg/88760_1681801347.png"
            value={formatUkNumber(activeUsers?.opt_out_count)}
            isLoading={activeUsersLoading}
          />
          {(companyId == 1 || companyId == 3) &&
            <StatCard
              title="In-Active Patients"
              subtitle={(companyId == 1 || companyId == 3) ? 'In-Active Patients' : 'Discharged Patients'}
              imgSrc="https://appcdn.goqii.com/storeimg/58427_1709296358.png"
              value={formatUkNumber(userData?.notLogin)}
              isLoading={activeUsersLoading}
            />
          }
          {companyId == 2 && (
            <>
              <StatCard
                title="First consultation"
                subtitle={'First consultation'}
                imgSrc="https://appcdn.goqii.com/storeimg/76526_1681803201.png"
                value={formatUkNumber(userData?.firstCall)}
                isLoading={activeUsersLoading}
              />
              <StatCard
                title="In-Active Patients"
                subtitle={(companyId == 1) ? 'In-Active Patients' : 'Discharged Patients'}
                imgSrc="https://appcdn.goqii.com/storeimg/58427_1709296358.png"
                value={formatUkNumber(userData?.inactiveUsers)}
                isLoading={activeUsersLoading}
              />
            </>
          )}
          <StatCard
            isClick={false}
            title=""
            subtitle={'Deleted Patients'}
            imgSrc="https://appcdn.goqii.com/storeimg/88760_1681801347.png"
            value={formatUkNumber(userData?.deleteCount)}
            isLoading={activeUsersLoading}
          />
        </div>
        <div className="row">
          {companyId == 1 && <>
            <StatCard
              otherClass="col-6 col-md-6 mt-3 px-1"
              title="Scheduled In-Clinic Appointments"
              subtitle={'Scheduled In-Clinic Appointments'}
              imgSrc="https://appcdn.goqii.com/storeimg/76526_1681803201.png"
              value={formatUkNumber(userData?.scheduledInClinicCount)}
              isLoading={fetchSuperviewInclinicCallLoading}
            />
            <StatCard
              otherClass="col-6 col-md-6 mt-3 px-1"
              title="Completed In-Clinic Appointments"
              subtitle={'Completed In-Clinic Appointments'}
              imgSrc="https://appcdn.goqii.com/storeimg/33669_1684235686.png"
              value={formatUkNumber(userData?.completedInClinicCount)}
              isLoading={fetchSuperviewInclinicCallLoading}
            />
          </>}
        </div>
        <div className="row">
          <StatCard
            otherClass="col-6 col-md-6 mt-3 px-1"
            title="Messages from Coach to Patient"
            subtitle={'Messages from Coach to Patient'}
            imgSrc="https://appcdn.goqii.com/storeimg/90527_1731929831.png"
            value={formatUkNumber(userData?.coachSentUserReceived)}
            isLoading={fetchSuperviewMesageGraphLoading}
          />
          <StatCard
            otherClass="col-6 col-md-6 mt-3 px-1"
            title="Messages from Patient to Coach"
            subtitle={'Messages from Patient to Coach'}
            imgSrc="https://appcdn.goqii.com/storeimg/90527_1731929831.png"
            value={formatUkNumber(userData?.userSentCoachReceived)}
            isLoading={fetchSuperviewMesageGraphLoading}
          />
        </div>
        <div className="row">
          <StatCard
            otherClass="col-6 col-md-2 mt-3 px-1"
            title="Scheduled Calls"
            subtitle={'Total Calls'}
            imgSrc="https://appcdn.goqii.com/storeimg/26476_1731930269.png"
            value={formatUkNumber(userData?.scheduledCalls)}
            isLoading={fetchSuperviewCallDetailLoading}
          />
          <StatCard
            otherClass="col-6 col-md-2 mt-3 px-1"
            title="Completed Calls"
            subtitle={'Completed Calls'}
            imgSrc="https://appcdn.goqii.com/storeimg/62955_1731930583.png"
            value={formatUkNumber(userData?.completedCalls)}
            isLoading={fetchSuperviewCallDetailLoading}
          />
          <StatCard
            otherClass="col-6 col-md-2 mt-3 px-1"
            title="Incomplete Calls"
            subtitle={'Incomplete Calls'}
            imgSrc="https://appcdn.goqii.com/storeimg/20839_1731931059.png"
            value={formatUkNumber(userData?.incompleteCalls)}
            isLoading={fetchSuperviewCallDetailLoading}
          />
          <StatCard
            otherClass="col-6 col-md-2 mt-3 px-1"
            title="Missed Calls"
            subtitle={'Missed Calls'}
            imgSrc="https://appcdn.goqii.com/storeimg/46802_1731931316.png"
            value={formatUkNumber(userData?.missedCalls)}
            isLoading={fetchSuperviewCallDetailLoading}
          />
          <StatCard
            otherClass="col-6 col-md-2 mt-3 px-1"
            title="Cancelled Calls"
            subtitle={'Cancelled Calls'}
            imgSrc="https://appcdn.goqii.com/storeimg/65691_1731930796.png"
            value={formatUkNumber(userData?.cancelledCalls)}
            isLoading={fetchSuperviewCallDetailLoading}
          />
          <StatCard
            otherClass="col-6 col-md-2 mt-3 px-1"
            title="Unsuccessful Calls"
            subtitle={'Unsuccessful Calls'}
            imgSrc="https://appcdn.goqii.com/storeimg/79726_1731931469.png"
            value={formatUkNumber(userData?.unsuccessfulCalls)}
            isLoading={fetchSuperviewCallDetailLoading}
          />
        </div>
      </div>
      {/* <ChartsSection
        userData={userData}
        seriesGraph={seriesGraph}
        loading={loading}
        startRange={startRange}
        endRange={endRange}
        divisionClinicFilter={divisionClinicFilter}
        programSelect={programSelect}
        graphDuration={graphDuration}
        coachRatingData={coachRatingData}
      /> */}
    </div>
  </>
});
